import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleFactorAdjustmentsConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationprojectCycleFactorAdjustments";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUN_FACTOR_ADJUSTMENTS = "DeleteMultipleprojectCycleFactorAdjustments";
    static FUNCTION_UPLOAD_GENERAL_VALUATION_RUN_FACTOR_ADJUSTMENTS = "UploadprojectCycleFactorAdjustments";
}
